/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used in labels.
 */
export const CORE_STRINGS = {
  account: `Account`,
  activate: `Activate`,
  activateAgency: `Activate an agency`,
  activateAgencyFailureMessage: `There was a problem activating this agency. Please contact us for support.`,
  activateAgencyLegend: `Agency configuration`,
  activateAgencyRefreshErrorMessage: `Reload page to see new agency`,
  activateAgencyRefreshMessage: `Refresh page to see agency.`,
  activateAgencySelection: `Select an agency to begin activation`,
  activateAgencySuccessMessage: `You can now activate organizations and assign them to `,
  activateAgencyUnavailable: `There are no agencies to activate.`,
  activateOrganisation: `Activate an organization`,
  activateOrganisationDisclaimerFunnelback: `Additional Funnelback instances will require activation after the organization has been created.`,
  activateOrganisationDisclaimerMatrix: `Matrix requires configuration after the organization has been created.`,
  activateOrganisationDisclaimerSearch: `Funnelback requires configuration after the organization has been created.`,
  activateOrganisationFailure: ` could not be activated`,
  activateOrganisationFailureMessage: `There was a problem activating this organization and its products. Please contact us for support.`,
  activateOrganisationLegend: `Organization configuration`,
  activateOrganisationLoading: `Loading subscription details for `,
  activateOrganisationProgress1: `Activating `,
  activateOrganisationProgress2: `This should take less than 1 minute.`,
  activateOrganisationRefreshErrorMessage: `Reload page to see new organization`,
  activateOrganisationSelection: `Select an organization to begin activation`,
  activateOrganisationSuccessMessage: `Your products are now ready for use or further activation through your new organization`,
  activateOrganisationUnavailable: `There are no organizations to activate.`,
  activateTenantRefreshError: `Failed to refresh`,
  activateTenantSuccess: ` has been successfully activated`,
  agenciesAndOrganisations: `Agencies and organizations`,
  agency: `Agency`,
  agencyId: `Agency ID`,
  agencyName: `Agency name`,
  agencyPlaceholder: `Select agency`,
  agencySettings: `Agency settings`,
  apiError: `There was a problem completing your request. Please try again later.`,
  backTo: `Back to`,
  backToAgenciesAndOrgs: `Back to agencies and organizations`,
  backToOrgs: `Back to organizations`,
  backToSignIn: `Back to sign in`,
  cancel: `Cancel`,
  capabilities: `Capabilities`,
  capabilitySwitcher: `Capability switcher`,
  change: `Change`,
  changesImmediate: 'This change will be immediate.',
  changesSaved: 'Changes saved',
  clientId: `Client ID`,
  close: `Close`,
  continue: `Continue`,
  createSetting: 'Create setting',
  customerSuggestions: `Customer suggestions`,
  deleteSetting: 'Delete setting',
  deleteSettingFailure: 'Could not delete setting',
  deleteSettingMessage:
    'If you delete this setting, services using it will be impacted. Make sure no DXP services are using this setting.',
  deleteSettingSuccess: 'Setting deleted',
  deleteThisSetting: 'Delete this setting',
  edit: 'Edit',
  editSetting: 'Edit setting',
  email: `Email`,
  error: `Error`,
  errorDetected: `Error detected`,
  errorIdp: `Something has gone wrong.`,
  errorIdpDetail: `Contact your organization administrator for more information.`,
  errorOrganisationId: `Enter lower case letters, numbers, dashes and underscores only (up to 32 characters). ID cannot be numbers only.`,
  errorUnauthorised: `Access denied`,
  errorUnauthorisedDetail: `If you think this is a mistake, contact your organization administrator for more information.`,
  errorUnknown: `Something has gone wrong.`,
  errorUnknownContact: 'Something went wrong. If this problem persists contact us for support.',
  errorUnknownDetail: `Try refreshing the page to resolve the issue. If this error continues, contact support.`,
  evaluation: `Evaluation`,
  findOutMore: `Find out more`,
  firstName: `First name`,
  helpAndResources: `Help and resources`,
  helpCenter: `Help Center`,
  hintFunnelbackInstanceName: `An acronym or short name followed by a dash then either website or intranet. For example, nab-website.`,
  hintOrganisationId: `The FinOpSys abbreviated name`,
  home: `Home`,
  instanceName: `Instance name`,
  invalidEmail: `Please enter a valid email address`,
  invalidEmails: `Please remove any invalid email addresses`,
  invalidPassword: `Password is invalid, please try again`,
  invalidSettingKey: 'Enter letters, numbers, and symbols (-_.#) only',
  lastName: `Last name`,
  loading: `Loading`,
  myAccount: `My account`,
  myAccountError: `Account details could not be updated. Please try again`,
  myAccountSuccess: `Account details updated`,
  mySquiz: `My Squiz`,
  name: 'Name',
  navigationSwitcher: `Navigation switcher`,
  next: 'Next',
  noAgenciesOrOrganisations: `There are no agencies or organizations to display.`,
  noAgenciesOrOrganisationsFound: `There are no matching agencies or organizations.`,
  noInstances: `There are no instances to display.`,
  noOrganisations: `There are no organizations to display.`,
  noOrganisationsFound: `There are no matching organizations.`,
  noPageAccess: `This page does not exist, or you are not authorized to access it.`,
  noSettings: 'There are no settings to show yet.',
  organisation: `Organization`,
  organisationDetailsToggle: `Show Details`,
  organisationId: `Organization ID`,
  organisationListSearchPlaceholder: `Search organizations`,
  organisationName: `Organization name`,
  organisations: `Organizations`,
  organisationSettings: `Organization settings`,
  password: `Password`,
  passwordConfirm: `Confirm your password`,
  passwordMatchError: `The passwords entered do not match`,
  passwordReset: `Password reset`,
  passwordResetButton: `Reset my password`,
  passwordResetError: `Password reset error!`,
  passwordResetSubtitle: `We will send you a password recovery link`,
  passwordResetSuccess: `Password recovery email was sent to`,
  passwordRule1: `at least one upper case letter (A-Z)`,
  passwordRule2: `at least one number (0-9)`,
  passwordRule3: `at least one special symbol (e.g. !?#$&*+=)`,
  passwordRulesIntro: `Your password must be at least 8 characters long and contain the following:`,
  products: `Products`,
  requiredField: `This field is required`,
  reset: `Reset`,
  resources: `Resources`,
  returnToSignIn: `Return to sign in`,
  save: `Save`,
  saveChanges: 'Save changes',
  schema: 'Schema',
  schemaSelectPlaceholder: 'Select a schema',
  service: 'Service',
  serviceSelectPlaceholder: 'Select a service',
  settingCreated: 'Setting created',
  settingExists: 'This setting already exists',
  settingKey: 'Setting key',
  settingKeyPlaceholder: 'Enter the {{settingKey}}',
  signIn: `Sign in`,
  signOut: `Sign out`,
  signup: `Set up your account`,
  signupButton: `Create account`,
  signupError: `Account could not be created. Please try again`,
  signupSuccess: `Account created`,
  tenantListDetailsToggle: `Show Details`,
  tenantListSearchPlaceholder: 'Search agencies or organizations',
  userDocumentation: `User documentation`,
  welcomeUser: `Welcome, {{user}}`,
};

/**
 * The strings used for products.
 */
export const PRODUCT_STRINGS = {
  connect: `Connect`,
  connectSubtitle: `Integration automation`,
  datastore: `Datastore`,
  datastoreSubtitle: `Digital data service`,
  funnelback: `Funnelback`,
  funnelbackAdminSubtitle: `Search`,
  funnelbackMarketingSubtitle: `Content analytics`,
  funnelbackSubtitle: `Search and analytics`,
  matrix: `Matrix`,
  matrixSubtitle: `Web content management`,
};

/**
 * The strings used for regions.
 */
export const REGION_STRINGS = {
  au: `Australia`,
  uk: `United Kingdom`,
  us: `United States`,
};
